import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { rgrnBarcodePrint } from "./rgrnbarcodePrint";

import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ComboService,
  JobWorkService,
  StockService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./jobRgrnComponent.html",
})
export class jobRgrnComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  designnoList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    rgrn_no: "",
    shirt_design_no: "",
    from_date: "",
    to_date: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "r.rgrn_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("FreshTemplate") FreshTemplate: TemplateRef<any>
  @ViewChild("DamTemplate") DamTemplate: TemplateRef<any>;
  @ViewChild("InwTemplate") InwTemplate: TemplateRef<any>;

  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  printPreview: any = [];
  brand: string;
  noofpcs: number;
  box: boolean;
  shirt: boolean;
  FreshPreview: any;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private rgrnService: JobWorkService,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private comboservice: ComboService,
    private stockService: StockService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.getDesignNoList();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Ref No",
        prop: "ref_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Date",
        prop: "date",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "RGRN No",
        prop: "rgrn_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "WO No",
        prop: "wo_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      //      {name: 'Party Code',prop: 'party_code',headerClass:'text-center', minWidth: 130,maxWidth: 130,width: 130 },
      {
        name: "Shirt DNo",
        prop: "shirt_design_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "F.Tot",
        prop: "ftot",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 70,
      },
      {
        name: "H.Tot",
        prop: "htot",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 70,
      },
      {
        name: "Total",
        prop: "tot",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 70,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      {
      name: "FreshPcs Sticker",
      prop: "sno",
      minWidth: 120,
      maxWidth: 120,
      width: 120,
      cellClass: "text-center",
      sortable: false,
      cellTemplate: this.FreshTemplate,
    },
      {
        name: "Barcode Print",
        prop: "sno",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        sortable: false,
        cellTemplate: this.InwTemplate,
      },
      {
        name: "DamagePcs Sticker",
        prop: "sno",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        cellClass: "text-center",
        sortable: false,
        cellTemplate: this.DamTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  bsModalRef: BsModalRef;
  printDet(row) {
    this.bsModalRef = this.modalService.show(rgrnBarcodePrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96",
    });
    this.bsModalRef.content.printdt = Object.assign({}, row);
  }

  getDamagePcs(row) {
    let params = {
      rgrn_id: row.rgrn_id,
    };

    
    let temp = [];
    this.rgrnService.getRgrnDamagePcs(params).then((res: any) => {
      // this.printPreview = res.data;
      temp = res.data;
      const map = {};
      temp.forEach((el) => {
        if (!map[JSON.stringify(el)]) {
          map[JSON.stringify(el)] = true;
          this.printPreview.push(el);
          console.log(this.printPreview);
        }
      });
    });
  }
  printer() {
    this.noofpcs = 1;
    if ($("#box").is(":checked")) {
      this.box = true;
    } else {
      this.box = false;
    }
    if ($("#shirt").is(":checked")) {
      this.shirt = true;
    } else {
      this.shirt = false;
    }
    if (this.box == false && this.shirt == false) {
      swal("PLEASE SELECT ATLEAST ONE");
    } else {
      $("#box").prop("checked", false);
      $("#shirt").prop("checked", false);
    }
    let params = {
      noofpcs: this.noofpcs,
      box: this.box,
      shirt: this.shirt,
      brand: this.brand,
      designdet: JSON.stringify(this.printPreview),
    };
    this.stockService.print(params).then((res: any) => {});
  }
  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }
  getDesignNoList() {
    let params = {};
    this.comboservice.getDesignCombo(params).then((res: any) => {
      this.designnoList = res;
    });
  }
  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.from_date = "";
    this.filter.to_date = "";
    this.filter.rgrn_no = "";
    this.filter.shirt_design_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getOrderList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }
  getFreshjobPcs(row) {
    let params = {
      rgrn_id: row.rgrn_id,
      brand : row.brand
    };
    this.rgrnService.getjobRgrnPcs(params).then((res: any) => {
      this.FreshPreview = res.data;
      if (res.data.length > 0) {
        let params = {
           type:"STOCK",
          designList: JSON.stringify(this.FreshPreview),
        };
        this.stockService.jobPcsPrint(params).then((res: any) => { });
      }

      else {
        swal("No Pcs Left In Stock!!!")
      }

    });
  }
  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD JOB RGRN DETAILS",
          title: "ADD JOB RGRN DETAILS",
          tabParent: "JOBWORK ORDER",
          mode: mode,
          data: row,
          name: "ADD JOB RGRN DETAILS",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT JOB RGRN DETAILS",
          title: "EDIT JOB RGRN DETAILS",
          tabParent: "JOBWORK ORDER",
          mode: mode,
          data: row,
          name: "EDIT JOB RGRN DETAILS",
        },
      };
    } else {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW JOB RGRN DETAILS",
          title: "VIEW JOB RGRN DETAILS",
          tabParent: "JOBWORK ORDER",
          mode: mode,
          data: row,
          name: "VIEW JOB RGRN DETAILS",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  // getStickerData(data) {
  //   let params = {
  //     rgrn_id: data.rgrn_id,
  //   };
  //   this.rgrnService.getStickerData(params).then((res: any) => {
  //     this.printSticker(res);
  //   });
  // }
  // printSticker(res) {
  //   let params = res.data;
  //   this.isLoadMask = this.rgrnService
  //     .printSticker(params)
  //     .then((res: any) => {});
  // }
  getOrderList(): void {
    if (this.filter.from_date) {
      this.filter.from_date = this.datePipe.transform(
        this.filter.from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.to_date) {
      this.filter.to_date = this.datePipe.transform(
        this.filter.to_date,
        "yyyy-MM-dd"
      );
    }

    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      from_date: this.filter.from_date,
      to_date: this.filter.to_date,
      shirt_design_no: this.filter.shirt_design_no,
      rgrn_no: this.filter.rgrn_no,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.rgrnService
      .getRgrnCuttingList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }

  deleteOrder(row: any): void {
    let that = this;
    swal({
      title: "Are you sure to delete this Cutting Details?",
      text: "You will not be able to recover this" + " " + row["cu_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.rgrnService
          .delete(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getOrderList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/jobworkorder/jobRgrnComponent.ts